import gsap from "gsap/gsap-core";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { ButtonSecondary, Container, ContentWrapper, devices } from "../../styles";
import { scrollToTop } from "../../utils";
import { dictionary } from "../../contexts/site";

export default function Intro({ setName }) {
  const history = useHistory();

  useEffect(() => {
    setName(null);
  }, [setName]);

  useEffect(() => {
    const elements = [...document.querySelectorAll(".fadeInUp")];

    const textAnimation = gsap.fromTo(
      elements,
      { autoAlpha: 0, y: 50 },
      {
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        stagger: 0.1,
      }
    );

    return () => {
      textAnimation.kill();
    };
  }, []);

  const fadeOutAnimation = () => {
    scrollToTop();
    gsap.to(".fadeOut", {
      duration: 0.5,
      opacity: 0,
    });
    gsap.to(".background-content-intro", {
      onComplete: () => history.push("/Mary/tutorial"),
    });
  };

  return (
    <Container>
      <IntroWrapper>
        <h1 className="fadeInUp fadeOut">{dictionary.intro.heading}</h1>
        <hr className="fadeInUp fadeOut" />
        <p className="fadeInUp fadeOut">{dictionary.intro.paragraph1}</p>
        <p className="fadeInUp fadeOut">{dictionary.intro.paragraph2}</p>
        <hr className="fadeInUp fadeOut" />
        <h2 className="fadeInUp fadeOut">{dictionary.intro.paragraph3}</h2>
        <ButtonSecondary
          className="fadeInUp fadeOut"
          onClick={() => fadeOutAnimation()}
          to="/Mary/tutorial" //to="/patient-selector"
        >
          <span>{dictionary.intro.cta}</span>
        </ButtonSecondary>
      </IntroWrapper>
    </Container>
  );
}

const IntroWrapper = styled(ContentWrapper)`
  text-align: center;


  h1 {
    max-width: 276px;
  }

  @media ${devices.M} {
    h1 {
      max-width: 442px;
    }
  }
  p {
    padding-left: 10px;
    padding-right: 10px;
  }
  hr {
    background-color: ${({ theme }) => theme.border};
    border: none;
    height: 1px;
    width: 40px;
    margin: 15px auto;

    @media ${devices.M} {
      margin: 20px auto;
    }
  }

  video {
    position: absolute;
    right: 0;
    height: 255px;
    top: 0;
  }

`;
